/******************************************************
 *                  Clients Ctrl
 ********************************************************/

"use strict";

angular.module("admin")

	.controller("AdminClientsCtrl", ["$rootScope","$scope", "toastr", "clients", "Utils", "$uibModal", "AdminClientsService", "SecurityService", "$location", "$controller", function ($rootScope,$scope, toastr, clients, Utils, $uibModal, AdminClientsService, SecurityService, $location, $controller) {

		$controller("AdminClientsCtrlParent", {$scope: $scope});

		/******************************************************
             *                  SETUP
             ********************************************************/
		$scope.data = {
			clients: clients.data,
			allClientsList : clients.data

		};

		var eraseModal, anonymizeModal;
		let availableReferentials;

		$rootScope.$watch('currentUserReferentials', ()=>{
			availableReferentials = $rootScope.currentUserReferentials;
			filterAvailableClients();
		});

		$scope.hasRight = (rightName) => SecurityService.hasRight(rightName);


		/******************
             * SCOPE FUNCTIONS
             ******************/

		/**
             * Déterminer sur quel environnement on est : on ne peut pas supprimer les données d'un client en prod
             */
		$scope.shouldEraseDataButtonBeDisplayed = function () {
			return $location.host() === "localhost" || "integ.okina.fr" || "demo.okina.fr" ;
		};

		/**
             * Supprimer les données d'un client.
             *
             * @param client
             */
		$scope.eraseClientData = function (client) {
			AdminClientsService.eraseClientData(client.id)
				.then(() => {
					toastr.success("Les données de l'organisation ont bien été effacées");
					eraseModal.close();
				})
				.catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de l'effacement des données de l'organisation.";
					if (data !== undefined && data.message) {
						errorMessage += "\n" + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		/**
             * Anonymiser les données d'un client.
             *
             * @param client
             */
		$scope.anonymizeClientData = function (client) {
			toastr.info("Cette opération va prendre quelques minutes.");
			anonymizeModal.close();
			AdminClientsService.anonymizeClientData(client.id);
		};

		/**
             * Ouvrir la modal de suppression des données d'un client.
             */
		$scope.openEraseModal = function (client) {
			$scope.data.clientToErase = client;
			eraseModal = Utils.openModal($uibModal, "erase.html", $scope);
		};

		/**
             * Ouvrir la modal pour anonymiser les données
             */
		$scope.openAnonymizeModal = function (client) {
			$scope.data.clientToAnonymize = client;
			anonymizeModal = Utils.openModal($uibModal, "anonymize.html", $scope);
		};


		function filterAvailableClients () {
			$scope.data.clients = $scope.data.allClientsList.filter(c => isClientInAvailableReferentials(c));
		}


		function isClientInAvailableReferentials(client) {
			return availableReferentials.some(ref => ref.code === client.code);
		}
	}]
	)
;
